import React from 'react';

const Card = ({ children, className = '' }) => {
  return (
    <div className={`bg-dark-800 rounded-xl border border-gray-800 shadow-lg shadow-black/20 ${className}`}>
      {children}
    </div>
  );
};

Card.Header = ({ children, className = '' }) => (
  <div className={`px-6 py-4 border-b border-gray-800 ${className}`}>
    {children}
  </div>
);

Card.Body = ({ children, className = '' }) => (
  <div className={`p-6 ${className}`}>
    {children}
  </div>
);

Card.Footer = ({ children, className = '' }) => (
  <div className={`px-6 py-4 border-t border-gray-800 ${className}`}>
    {children}
  </div>
);

export default Card;
